import { IHeaderParams } from "@ag-grid-enterprise/all-modules";
import RequestTimeRange from "components/RequestTimeRange";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { DateRangeFilterContext } from "utils/context";
import "components/RequestTimeRange.scss";

export default function RequestTimeHeader({ displayName, column, progressSort, api }: IHeaderParams) {
    const [sort, setSort] = useState<string | null>(column.getSort());
    const [filterRange] = useContext(DateRangeFilterContext);
    const [isFilter, setIsFilter] = useState(false);

    const onSortChanged = useCallback(() => {
        setSort(column.getSort());
    }, [column]);

    useEffect(() => {
        api.addEventListener("sortChanged", onSortChanged);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const [from, to] = filterRange;
        setIsFilter(!!from || !!to);
    }, [filterRange]);

    const handleSortClick = useCallback(
        (e) => {
            progressSort(e.shiftKey);
        },
        [progressSort]
    );

    return (
        <div className="ag-cell-label-container ag-header-cell-sorted" onClick={handleSortClick}>
            <span
                className="ag-header-icon ag-header-cell-menu-button ag-header-menu-always-show"
                onClick={(e) => e.stopPropagation()}
            >
                <RequestTimeRange />
            </span>
            <div className="ag-header-cell-label ">
                <span className="ag-header-cell-text">{displayName}</span>
                <span className="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true">
                    <span className={`ag-icon ag-icon-filter ${isFilter ? null : "ag-hidden"} `}></span>
                </span>

                <span className={`ag-header-icon ag-header-label-icon ag-sort-icon`}>
                    <span className={`ag-icon ag-icon-${sort} ${sort === "none" ? "ag-hidden" : undefined}`}></span>
                </span>
            </div>
        </div>
    );
}
